/**
*
* Hides the Navigationbar when you scroll down, and shows it, when you scroll up again.
*
* */
const IS_TOP_CLASS = 'is-top';
const HEADER_SELECTOR = '.js-hide-in-scroll';
const HIDDEN_CLASS = 'c-header--hidden';
let PREVIOUS_POSITION = 0;

export function moveHeaderListener(): void {
    const header = document.querySelector(HEADER_SELECTOR);
    if (!header) {
        return;
    }

    PREVIOUS_POSITION = window.pageYOffset;
    window.addEventListener('scroll', () => {
        const currentScrollPos = window.pageYOffset;
        if (PREVIOUS_POSITION > currentScrollPos) {
            header.classList.remove(HIDDEN_CLASS);
        } else {
            header.classList.add(HIDDEN_CLASS);
        }

        PREVIOUS_POSITION = currentScrollPos;
        isHeaderTop(header);
    }, { passive: true });
}

function isHeaderTop(header: Element): void {
    const headerScrollAmount = 140;
    let elementPosition: Element = document.documentElement;
    elementPosition = (elementPosition.clientHeight) ? elementPosition : document.body;

    if (elementPosition.scrollTop === 0) {
        header.classList.add(IS_TOP_CLASS);
        header.classList.remove(HIDDEN_CLASS);
    } else if (elementPosition.scrollTop >= headerScrollAmount) {
        header.classList.remove(IS_TOP_CLASS);
    }
}

export function openHeaderSearch(): void {
    const searchTrigger = document.querySelector<HTMLElement>('.js-trigger-search-input');
    const searchContainer = document.querySelector<HTMLElement>('.js-search-container');
    const searchInput = document.querySelector<HTMLInputElement>('.search-input');
    const body = document.querySelector<HTMLElement>('body');
    const isOpen = 'is-open';

    if (searchTrigger && searchContainer && body) {
        searchTrigger.addEventListener('click', (event) => {
            if (searchInput) {
                searchContainer.classList.add(isOpen);
                searchInput.focus();
                event.stopPropagation();
            }

            searchContainer.addEventListener('click', (event)=> {
                event.stopPropagation();
            });

            body.addEventListener('click', () => {
                searchContainer.classList.remove(isOpen);
            });
        })
    }
}
